module.exports = __webpack_public_path__ + "8e2d9707f29e2bc035a90c716c96e9f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mapa-resplendor.png
// module id = 77
// module chunks = 0